import { createTheme } from "@mui/material/styles";

export const COLORS ={
    while:"#FFFFFF"
}
export const theme = createTheme({
  palette: {
    primary: { main: "#1F4D2B" },
    secondary: { main: "#D27C3A" },
    background: {
      default: "#FAF8F2",
      paper: "#FFFFFF"
    }
  },
  typography: {
    fontFamily: "Inter, sans-serif",
    h1: {
      fontFamily: "Playfair Display, serif",
      fontWeight: 700,
      fontSize: "3.2rem",
      lineHeight: 1.2
    },
    h2: {
      fontFamily: "Playfair Display, serif",
      fontWeight: 600,
      fontSize: "2.4rem"
    },
    h5: {
      fontWeight: 600
    }
  },
  shape: {
    borderRadius: 16
  }
});